/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Eye from './eye';
import EyeDetail from './eye-detail';
import EyeUpdate from './eye-update';
import EyeDeleteDialog from './eye-delete-dialog';

const EyeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Eye />} />
    <Route path="new" element={<EyeUpdate />} />
    <Route path=":id">
      <Route index element={<EyeDetail />} />
      <Route path="edit" element={<EyeUpdate />} />
      <Route path="delete" element={<EyeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default EyeRoutes;
